import { createReducer, on } from '@ngrx/store';

import { DataspaceState } from '../../models/dataspace/dataspace-state.model';
import * as DataspaceActions from './dataspace.actions';

export const initialDataspaceState: DataspaceState = {
  dataspace: undefined,
  availableEntities: [],
  availableTransformers: [],
  transformersInfo: [],
  error: undefined
};

export const dataspaceReducer = createReducer<DataspaceState>(
  initialDataspaceState,

  // Clear error when new fetch starts (only for same dataspace ID)
  on(DataspaceActions.fetchDataspace, (state, { id }) => ({
    ...state,
    error: state.error?.dataspaceId === id ? undefined : state.error
  })),

  // Success: clear error, set dataspace
  on(
    DataspaceActions.switchToDataspace,
    (state, { dataspace, availableEntities, availableTransformers, transformersInfo }) => ({
      ...state,
      dataspace,
      availableEntities,
      availableTransformers,
      transformersInfo,
      error: undefined
    })
  ),

  // Failure: set error state with details
  on(DataspaceActions.fetchDataspaceFailure, (state, { id, error }) => {
    console.warn('Dataspace fetch failed for ID:', id, error);

    // Extract HTTP status from error object (handle various formats)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const errorObj = error as any;
    const httpStatus = errorObj?.status || errorObj?.httpStatus;
    const message = errorObj?.message || errorObj?.error?.message || 'Unknown error';

    return {
      ...state,
      error: {
        dataspaceId: id,
        httpStatus,
        message,
        timestamp: Date.now()
      }
    };
  })
);
